/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetGroups200ResponseInner
 */
export interface GetGroups200ResponseInner {
    /**
     * 無線グループID
     * @type {string}
     * @memberof GetGroups200ResponseInner
     */
    companyCode: string;
    /**
     * 無線グループ名
     * @type {string}
     * @memberof GetGroups200ResponseInner
     */
    groupName: string;
    /**
     * API区分 (1:P0, 2:API)
     * @type {string}
     * @memberof GetGroups200ResponseInner
     */
    category: string;
}

/**
 * Check if a given object implements the GetGroups200ResponseInner interface.
 */
export function instanceOfGetGroups200ResponseInner(value: object): value is GetGroups200ResponseInner {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function GetGroups200ResponseInnerFromJSON(json: any): GetGroups200ResponseInner {
    return GetGroups200ResponseInnerFromJSONTyped(json, false);
}

export function GetGroups200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroups200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCode': json['company_code'],
        'groupName': json['group_name'],
        'category': json['category'],
    };
}

export function GetGroups200ResponseInnerToJSON(json: any): GetGroups200ResponseInner {
    return GetGroups200ResponseInnerToJSONTyped(json, false);
}

export function GetGroups200ResponseInnerToJSONTyped(value?: GetGroups200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_code': value['companyCode'],
        'group_name': value['groupName'],
        'category': value['category'],
    };
}

